export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!
export const GAME_VERSION = process.env.REACT_APP_VERSION!
export const WIN_MESSAGES = ['அருமை!', 'நல்வாழ்த்து', 'மிக நன்று!']
export const GAME_COPIED_MESSAGE = 'முடிவுகள் பகிர நகலெடுக்கப்பட்டது'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'குறைந்த எழுத்து எண்ணிக்கை'
export const WORD_NOT_FOUND_MESSAGE = 'சொல் காணவில்லை'
export const HARD_MODE_ALERT_MESSAGE =
  'கடுமை நிலையை விளையாட்டு தொடங்கும் முன் இயக்க வேண்டும்! நடுவில் முடியாது!'
export const HARD_MODE_DESCRIPTION =
  'குறிக்கப்பட்ட எழுத்துகளை அடுத்தடுத்த முயற்சிகளில் பயன்படுத்தப்பட வேண்டும்'
export const HIGH_CONTRAST_MODE_DESCRIPTION = 'மிகைத்த மேம்பட்ட நிறப்பார்வை'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `சரியான சொல் : ${solution}`
export const WRONG_SPOT_MESSAGE = (guess: string, position: number) =>
  `சொல்லில் ${guess} எழுத்து கண்டிப்பாக ${position}-ஆம் இடத்தில் வரவேண்டும்!`
export const NOT_CONTAINED_MESSAGE = (letter: string) =>
  `சொல்லில் ${letter} எழுத்து கண்டிப்பாக இடம்பெற வேண்டும்!`
export const STATISTICS_TITLE = 'புள்ளியல்'
export const GUESS_DISTRIBUTION_TEXT = 'முயற்சிகள்'
export const NEW_WORD_TEXT = 'அடுத்த சொல்'
export const SHARE_TEXT = 'பகிர்'
export const TOTAL_TRIES_TEXT = 'விளையாட்டு'
export const SUCCESS_RATE_TEXT = 'வெற்றி'
export const CURRENT_STREAK_TEXT = 'தொடர் வெற்றி'
export const BEST_STREAK_TEXT = 'சிறந்த தொடர்'